module.exports = __webpack_public_path__ + "img/1.11.1_Russian_road_sign.0f53a30d.svg";